import { render, staticRenderFns } from "./BarComponent.vue?vue&type=template&id=5b6dff39&"
import script from "./BarComponent.vue?vue&type=script&lang=js&"
export * from "./BarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports